module.exports = __webpack_public_path__ + "assets/img/slogan-060debd1.png";